var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 4.47A4.47 4.47 0 0 1 4.47 0h11.06A4.47 4.47 0 0 1 20 4.47v2.412C20 7.5 19.5 8 18.882 8H12V7a2 2 0 1 0-4 0v1H1.118C.5 8 0 7.5 0 6.882zM8 9H2.235C1.001 9 0 10 0 11.235V17a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-5.765C20 10.001 19 9 17.765 9H12a2 2 0 1 1-4 0",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4,
    x: 9,
    y: 6,
    fill: "currentColor",
    rx: 1
  })));
};
export default SvgBox;